<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true" :is-quick-attached="true">
    <template v-slot>
      <div v-if="data.popup.popupVisible" class="dialog type-non-footer">
        <header class="dialog-header">
          <h2 class="dialog-title only-pc">페인트양 계산하기</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">페인트양 계산하기</h3>

            <div class="m-paint-wrap">
              <div class="paint-guide">
                <img src="@/assets/images/etc/img_paint.svg" alt="가로 세로" />
              </div>

              <div class="paint-input">
                <div class="input-set">
                  <label for="horizontal-length">가로길이(m)</label>
                  <div class="c-input-group type-medium">
                    <input
                      type="number"
                      id="horizontal-length"
                      v-model="data.biz1.wt"
                      title="가로길이(m)"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="gap">
                  <i class="c-icon icon-small-x"></i>
                </div>
                <div class="input-set">
                  <label for="vertical-length">세로길이(m)</label>
                  <div class="c-input-group type-medium">
                    <input
                      type="number"
                      id="vertical-length"
                      v-model="data.biz1.ht"
                      title="세로길이(m)"
                      placeholder="0"
                    />
                  </div>
                </div>
              </div>

              <p class="description">
                정수, 소수점 둘째자리까지 입력 가능합니다.
              </p>

              <div class="c-btn-area flex-inline">
                <!-- D: 계산하기 클릭시 스크롤 하단으로 이동 -->
                <button
                  type="button"
                  class="c-button type-primary"
                  data-scroll-down
                  @click="btnCmd('sum_btn')"
                >
                  <span>계산하기</span>
                </button>
              </div>

              <div class="calc-result">
                <div class="calc-item">
                  <em>면적은</em>
                  <div class="c-input-group type-medium">
                    <input
                      type="text"
                      v-model="data.biz1.paint_area"
                      disabled
                    />
                  </div>
                  <p>㎡이고,</p>
                </div>
                <div class="calc-item">
                  <em>페인트양은</em>
                  <div class="c-input-group type-medium">
                    <input
                      type="text"
                      v-model="data.biz1.paint_quantity"
                      disabled
                    />
                  </div>
                  <p>L(리터)입니다.</p>
                </div>
              </div>

              <div class="c-round-box">
                <ul class="c-dot-list type-small">
                  <li>
                    기본적으로 2회 페인팅 기준으로 산출되며 최소 계산량은
                    0.1L입니다 (기준량 이하는 0으로 표시)
                  </li>
                  <li>
                    페인트의 양은 두께와 칠하는 표면의 상태, 사용자의 작업
                    방법에 따라 다소 차이가 있을 수 있습니다.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>

<script setup name="paintQuantityCalcPop">
import { onMounted, defineEmits, reactive, ref } from "vue";
import * as cmUtil from "@/utils/cmUtil.js";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
const emits = defineEmits(["close"]);

// const props = defineProps({
//   visible: {
//     type: Boolean,
//     require: false,
//   },
// });

const data = reactive({
  popup: {
    popupVisible: false,
  },
  biz1: {
    wt: null,
    ht: null,
    paint_area: 0,
    paint_quantity: 0,
  },
});

const product = ref(null);

// watch(
//   () => props.visible,
//   (newValue) => {
//     data.popup.popupVisible = newValue;
//   }
// );

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  // searchCmd("biz1#search"); // biz1 데이타 조회
  data.popup.popupVisible = true;

  product.value = {
    aa: "aaa",
    bb: "bbb",
    stockList: [],
    linkList: [],
    bomItemList: [],
  };
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "close") {
    cmUtil.removeClassPopupOpen();
    emits("close");
  } else if (cmd === "sum_btn") {
    cmUtil.removeClassPopupOpen();
    goComplex();
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

/**********************
 * 기티함수 모음
 *********************/

//숫자만, 소수점 둘째자리까지 입력 가능
// function checkNumberDot(_value) {
//   if (
//     _value.indexOf("0") == 0 &&
//     _value.length > 1 &&
//     _value.indexOf("0.") != 0
//   ) {
//     return false;
//   }

//   var num_check = /^\d*(\d+\.?\d\d?)?$/;
//   return num_check.test(_value);
// }

//페인트 양 계산
function goComplex() {
  var wt = data.biz1.wt;
  var ht = data.biz1.ht;

  if (wt == "") {
    alert("벽면의 넓이(가로) 크기를 입력해 주십시오.");
    return;
  }

  // if (!checkNumberDot(wt)) {
  //   alert("정수 또는 소수점 둘째짜리까지 입력 가능합니다.");
  //   data.biz1.wt = "";
  //   return;
  // }

  if (ht == "") {
    alert("벽면의 높이(세로) 크기를 입력해 주십시오.");
    return;
  }

  // if (!checkNumberDot(ht)) {
  //   alert("정수 또는 소수점 둘째짜리까지 입력 가능합니다.");
  //   data.biz1.ht = "";
  //   return;
  // }

  var area = wt * ht;

  data.biz1.paint_area = roundXL(area, 1);
  var cmp = "ALL";
  if (cmp == "ONE") {
    data.biz1.paint_quantity = roundXL((area / 7) * 0.68, 1);
  } else {
    data.biz1.paint_quantity = roundXL(area / 7, 1);
  }
}

function roundXL(n, digits) {
  if (digits >= 0) {
    return parseFloat(n.toFixed(digits)); // 소수부 반올림
  }
  digits = Math.pow(10, digits); // 정수부 반올림
  var t = Math.round(n * digits) / digits;
  return parseFloat(t.toFixed(0));
}
</script>
<style scoped></style>
